import { Box, Grid, Stack } from "@mui/material";
import { GridItem } from "Components/Shared/GridItem";
import { FormSection } from "Components/Shared/FormSection";
import { RegistryLinks } from "Components/Shared/RegistryLinks/RegistryLinks";
import type { PartyDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { formatPhone } from "Utils/PhoneUtils";

const RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.Party.Form.LegalEntity;

type Props = {
  party: PartyDto;
};

export const LegalEntitySection = ({
  party: { companyName, companyNumber, taxNumber, vatNumber, phone, email },
}: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={4}>
      <FormSection legend={t(RESOURCES.Legend.Company)} noMargins>
        <Grid container spacing={2}>
          <GridItem label={t(RESOURCES.CompanyName)} value={companyName} />
          <GridItem label={t(RESOURCES.CompanyNumber)} value={companyNumber} />
          <GridItem label={t(RESOURCES.TaxNumber)} value={taxNumber} />
          <GridItem label={t(Resources.Common.VatNumber)} value={vatNumber} />
        </Grid>
        {companyNumber && (
          <Box mt={2}>
            <RegistryLinks companyNumber={companyNumber} />
          </Box>
        )}
      </FormSection>
      <FormSection legend={t(RESOURCES.Legend.Contact)} noMargins>
        <Grid container spacing={2}>
          <GridItem
            columns={2}
            label={t(RESOURCES.Phone)}
            value={formatPhone(phone)}
          />
          <GridItem columns={2} label={t(RESOURCES.Email)} value={email} />
        </Grid>
      </FormSection>
    </Stack>
  );
};
